import React, { useState } from 'react';
import Modal from '../common/Modal';
import { useApp } from '../../contexts/AppContext';

export default function AddUserModal({ isOpen, onClose }) {
  const { addUser } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setUsername('');
    setPassword('');
    setRole('user');
    setError('');
  };

  const handleSubmit = async () => {
    if (!username || !password) {
      setError('Username and password are required');
      return;
    }

    setError('');
    setLoading(true);

    try {
      await addUser(username, password, role);
      resetForm();
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create user');
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <>
      <button 
        className="btn btn-secondary" 
        type="button" 
        onClick={() => { resetForm(); onClose(); }}
        disabled={loading}
      >
        Cancel
      </button>
      <button 
        className="btn btn-primary" 
        type="button" 
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Creating...' : 'Create User'}
      </button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={() => { resetForm(); onClose(); }} title="Create New User" footer={footer}>
      {error && <div className="form-error" style={{ marginBottom: '1rem' }}>{error}</div>}
      <div className="form-group-modal">
        <label htmlFor="new-username">Username *</label>
        <input
          id="new-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          autoComplete="username"
          disabled={loading}
        />
      </div>
      <div className="form-group-modal">
        <label htmlFor="new-password">Password *</label>
        <input
          id="new-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          autoComplete="new-password"
          disabled={loading}
        />
      </div>
      <div className="form-group-modal">
        <label htmlFor="new-role">Role *</label>
        <select 
          id="new-role" 
          value={role} 
          onChange={(e) => setRole(e.target.value)}
          disabled={loading}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
      </div>
    </Modal>
  );
}
